import { Component, inject } from '@angular/core';
import { LaunchDarklyService } from '../../../core/services/launchdarkly.service';
import { CommonModule } from '@angular/common';
import { LayoutService } from '../layout.service';
import { BxGlobalNotificationsModule } from '../../../core/components/bx-global-notifications/bx-global-notifications.module';

@Component({
    selector: 'app-global-header',
    templateUrl: './global-header.component.html',
    styleUrls: ['./global-header.component.scss'],
    standalone: true,
    imports: [CommonModule, BxGlobalNotificationsModule],
})
export class GlobalHeaderComponent {
    lds = inject(LaunchDarklyService);
    layoutService = inject(LayoutService);
}
